module.exports = __webpack_public_path__ + "bee470c1cb9f6d551b7ac390804da3dc.svg";